import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { buildApi, get, patch, post, put } from '@applyboard/redux-bees';
import getCsrf from "../util/getCsrf";
import { API_ROOT } from "../constants/consts";
// Original redux-bees `destroy` method does not allow sending a body. This fixes it.
var destroy = function destroy() {
  var placeholders = arguments.length <= 0 ? undefined : arguments[0];
  var body = arguments.length >= 2 ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0];
  var options = arguments.length === 3 ? arguments.length <= 2 ? undefined : arguments[2] : {};
  return {
    placeholders: placeholders,
    options: _objectSpread({
      method: 'DELETE',
      mode: 'cors',
      body: body && JSON.stringify(body)
    }, options)
  };
};
var apiEndpoints = {
  // Users
  getUser: {
    method: get,
    path: '/users/:id'
  },
  getCurrentUser: {
    method: get,
    path: '/v2/me'
  },
  getMenuItems: {
    method: get,
    path: '/v2/menu_items'
  },
  getUsersLegacyRoles: {
    method: get,
    path: '/users/legacy_roles'
  },
  deleteUserProfilePicture: {
    method: destroy,
    path: '/users/:id/profile_picture'
  },
  patchUserPassword: {
    method: patch,
    path: '/users/:id/password'
  },
  patchUserUsername: {
    method: patch,
    path: '/users/:id/change_username'
  },
  patchUserEmail: {
    method: patch,
    path: '/users/:id/change_email'
  },
  patchUserBlock: {
    method: patch,
    path: '/users/:id/block'
  },
  patchUserUnblock: {
    method: patch,
    path: '/users/:id/unblock '
  },
  patchUserAssignRoles: {
    method: patch,
    path: '/users/:id/assign_role'
  },
  patchUserLegacyRole: {
    method: patch,
    path: '/users/:id/change_legacy_role'
  },
  putUserAccessScopes: {
    method: put,
    path: '/users/:id/access_scope_condition'
  },
  getUserProfile: {
    method: get,
    path: '/profiles/:id'
  },
  patchUserProfile: {
    method: patch,
    path: '/profiles/:id'
  },
  getCountries: {
    method: get,
    path: '/v2/countries'
  },
  getSchool: {
    method: get,
    path: '/schools/:id'
  },
  getSchools: {
    method: get,
    path: '/v2/schools'
  },
  getSchoolsSearch: {
    method: get,
    path: '/v2/schools_search'
  },
  getProgramLevels: {
    method: get,
    path: '/education_levels'
  },
  getSchoolPrograms: {
    method: get,
    path: '/schools/:id/programs'
  },
  getSchoolProgram: {
    method: get,
    path: '/v2/programs/:id'
  },
  postAnonymousSchoolEligibilityCheck: {
    method: post,
    path: '/v2/schools/:school_id/check_eligibility'
  },
  postAnonymousProgramEligibilityCheck: {
    method: post,
    path: '/v2/programs/:program_id/check_eligibility'
  },
  getStudentProgramEligibilityCheck: {
    method: get,
    path: '/v2/programs/:program_id/check_eligibility/:user_id'
  },
  getProgramDisclaimerRequirements: {
    method: get,
    path: '/v2/programs/:program_id/disclaimer_requirements/:user_id'
  },
  deleteStudentsCharge: {
    method: destroy,
    path: '/students/:student_id/orders/:id'
  },
  getStudent: {
    method: get,
    path: '/students/:id'
  },
  getStudentsSearch: {
    method: get,
    path: '/v2/students_search'
  },
  getStudentsOrders: {
    method: get,
    path: '/students/:id/orders'
  },
  getStudentTestScores: {
    method: get,
    path: '/students/:id/test_scores'
  },
  postStudentsCharge: {
    method: post,
    path: '/students/:id/orders'
  },
  patchStudentPremiumStatus: {
    method: patch,
    path: '/students/:id/toggle-student-premium-status'
  },
  getStudentApplications: {
    method: get,
    path: '/students/:id/applications'
  },
  putStudentsAgency: {
    method: put,
    path: '/students/:id/agency'
  },
  destroyStudentsAgency: {
    method: destroy,
    path: '/students/:id/agency'
  },
  putStudentsSalesRep: {
    method: put,
    path: '/students/:id/sales_representative'
  },
  destroyStudentsSalesRep: {
    method: destroy,
    path: '/students/:id/sales_representative'
  },
  patchAgentAgreement: {
    method: patch,
    path: '/v2/agent_informations/:agency_id/agent_agreement'
  },
  deleteAgentsCharge: {
    method: destroy,
    path: '/agents/:agent_id/orders/:id'
  },
  getAgentsOrders: {
    method: get,
    path: '/agents/:id/orders'
  },
  postAgentsCharge: {
    method: post,
    path: '/agents/:id/orders'
  },
  postServiceFeeWaivers: {
    method: post,
    path: '/v2/order_item_fee_waivers'
  },
  destroyServiceFeeWaivers: {
    method: destroy,
    path: '/v2/order_item_fee_waivers/:order_item_id'
  },
  patchPayments: {
    method: patch,
    path: '/v2/payments/:id'
  },
  patchPaymentsVerifyManualPaymentReceipt: {
    method: patch,
    path: '/v2/payments/:id/verify_manual_payment_receipt'
  },
  patchPaymentsDeleteManualPaymentReceipt: {
    method: patch,
    path: '/v2/payments/:id/delete_manual_payment_receipt'
  },
  destroyPromotions: {
    method: destroy,
    path: '/promotions/:id'
  },
  getPromotions: {
    method: get,
    path: '/promotions'
  },
  patchPromotions: {
    method: patch,
    path: '/promotions/:id'
  },
  postPromotions: {
    method: post,
    path: '/promotions'
  },
  getOrders: {
    method: get,
    path: '/orders/:id'
  },
  patchOrders: {
    method: patch,
    path: '/orders/:id'
  },
  getBillingAccounts: {
    method: get,
    path: '/billing_accounts/:id'
  },
  // include=payments
  payOrder: {
    method: patch,
    path: '/orders/:id/pay'
  },
  // + id, billing_account_id, use_credit, token (stripe only), payment_method=stripe|account_credit|bank_transfer, receipt_file (bank_transfer only)

  createPayment: {
    method: post,
    path: '/payments/v1/payments'
  },
  postTransaction: {
    method: post,
    path: '/payments/v1/transactions/:action'
  },
  getAgencyRegistrationRequests: {
    method: get,
    path: '/agency_registration_requests'
  },
  getAgencyRegistration: {
    method: get,
    path: '/agency_registration_requests/:id'
  },
  patchAgencyRegistration: {
    method: patch,
    path: '/agency_registration_requests/:id'
  },
  patchAgencyRegistrationApprove: {
    method: patch,
    path: '/agency_registration_requests/:id/approve'
  },
  patchAgencyRegistrationReject: {
    method: patch,
    path: '/agency_registration_requests/:id/reject'
  },
  postAgencyRegistration: {
    method: post,
    path: '/agency_registration_requests'
  },
  patchAgencyRegistrationSetUnderReview: {
    method: patch,
    path: '/agency_registration_requests/:id/set_under_review'
  },
  patchAgencyRegistrationUnsetUnderReview: {
    method: patch,
    path: '/agency_registration_requests/:id/unset_under_review'
  },
  getAgencyAdminComments: {
    method: get,
    path: '/agencies/:agency_id/admin_comments'
  },
  postAgencyAdminComment: {
    method: post,
    path: '/agencies/:agency_id/admin_comments'
  },
  destroyAgencyAdminComment: {
    method: destroy,
    path: '/agencies/:agency_id/admin_comments/:id'
  },
  deleteAgencyManager: {
    method: destroy,
    path: '/agencies/:id/agent_manager'
  },
  getAgencies: {
    method: get,
    path: '/agencies'
  },
  getAgency: {
    method: get,
    path: '/agencies/:id'
  },
  getRpSearch: {
    method: get,
    path: '/v2/rp_search'
  },
  getAgencyAgentManager: {
    method: get,
    path: '/agencies/:id/agent_manager'
  },
  getAgencyApplicationStats: {
    method: get,
    path: '/agencies/:id/applications_stats'
  },
  getAgencyBankingInformation: {
    method: get,
    path: '/agencies/:id/banking_information'
  },
  getAgencyBillingAccount: {
    method: get,
    path: '/agencies/:id/billing_account'
  },
  getAgencyCommissionPolicy: {
    method: get,
    path: '/agencies/:id/commission_policy'
  },
  getAgencySalesRepresentative: {
    method: get,
    path: '/agencies/:id/sales_representative'
  },
  patchAgency: {
    method: patch,
    path: '/agencies/:id'
  },
  patchAgencyBankingInformation: {
    method: patch,
    path: '/agencies/:id/banking_information'
  },
  patchAgencyCommissionPolicy: {
    method: patch,
    path: '/agencies/:id/commission_policy'
  },
  patchAgencySendActivationEmail: {
    method: patch,
    path: '/agencies/:id/send_activation_email'
  },
  postAgencyReferralCode: {
    method: post,
    path: '/agencies/:id/referral_code'
  },
  putAgencyManager: {
    method: put,
    path: '/agencies/:id/agent_manager'
  },
  getAgencySchoolCommissions: {
    method: get,
    path: '/agencies/:id/school_commissions'
  },
  patchAgencyActivation: {
    method: patch,
    path: '/agencies/:id/activate'
  },
  patchAgencyDeactivation: {
    method: patch,
    path: '/agencies/:id/deactivate'
  },
  patchAgencySuspension: {
    method: patch,
    path: '/agencies/:id/suspend'
  },
  postAgencyStaffInvitation: {
    method: post,
    path: '/agencies/:id/agency_staff_invitations'
  },
  getAgencyStaffInvitations: {
    method: get,
    path: '/agencies/:id/agency_staff_invitations'
  },
  postAgencySendStaffInvitation: {
    method: post,
    path: '/agencies/:owner_id/agency_staff_invitations/:staff_id/send_invitation'
  },
  patchAgencyStaffLimit: {
    method: patch,
    path: '/agencies/:id/update_staff_limit'
  },
  patchAgencyAutoAddSchools: {
    method: patch,
    path: '/agencies/:id/update_auto_add_new_schools'
  },
  patchAgencyReassignStudents: {
    method: patch,
    path: '/agencies/:id/reassign_staff_students'
  },
  getPaidApplicationsCountForAgent: {
    method: get,
    path: '/agencies/:id/agency_stats/paid_applications_count'
  },
  getPaidStudentsCountForAgent: {
    method: get,
    path: '/agencies/:id/agency_stats/paid_students_count'
  },
  getEarliestPaidStudentDateForAgent: {
    method: get,
    path: '/agencies/:id/agency_stats/earliest_paid_student_date'
  },
  // index
  getStudentImmigrationConsultants: {
    method: get,
    path: '/students/immigration_consultants'
  },
  // show
  getImmigrationConsultant: {
    method: get,
    path: '/immigration_consultants/:id'
  },
  putStudentImmigrationConsultant: {
    method: put,
    path: '/students/:id/immigration_consultant'
  },
  destroyStudentImmigrationConsultant: {
    method: destroy,
    path: '/students/:id/immigration_consultant'
  },
  getSalesRepresentatives: {
    method: get,
    path: '/sales_representatives'
  },
  getStudentSalesRepresentatives: {
    method: get,
    path: '/students/sales_representatives'
  },
  getSalesRepresentative: {
    method: get,
    path: '/sales_representatives/:id'
  },
  getAgentManagers: {
    method: get,
    path: '/agent_managers'
  },
  getAgentManager: {
    method: get,
    path: '/agent_managers/:id'
  },
  getAgencyEmployee: {
    method: get,
    path: '/agency_employees/:id'
  },
  putAgencyEmployee: {
    method: put,
    path: '/agency_employees/:id'
  },
  getEducationHistories: {
    method: get,
    path: '/students/:student_id/attended_schools'
  },
  postEducationHistories: {
    method: post,
    path: '/students/:student_id/attended_schools/'
  },
  putEducationHistories: {
    method: put,
    path: '/students/:student_id/attended_schools/:school_id'
  },
  deleteEducationHistories: {
    method: destroy,
    path: '/students/:student_id/attended_schools/:school_id'
  },
  getSchoolsList: {
    method: get,
    path: '/countries/:country_code/educational_institutions'
  },
  getSchoolAddress: {
    method: get,
    path: '/countries/:country_code/educational_institutions/:school_id'
  },
  getApplicationsSearch: {
    method: get,
    path: '/v2/applications_search'
  },
  getIeltsResults: {
    method: get,
    path: '/integrations/verify_ielts'
  },
  createApplyStuEmail: {
    method: post,
    path: '/integrations/create_applyboard_email'
  },
  getStudentProfileDocuments: {
    method: get,
    path: '/students/:student_id/student_profile_documents'
  },
  deleteStudentProfileDocumentsAttachment: {
    method: destroy,
    path: '/students/:student_id/student_attachments/:id'
  },
  getCustomFields: {
    method: get,
    path: '/custom_fields'
  },
  getCustomFieldDefinitions: {
    method: get,
    path: '/custom_field_definitions'
  },
  getStudentCustomFields: {
    method: get,
    path: '/students/:id/custom_fields'
  },
  postStudentCustomFields: {
    method: post,
    path: '/students/:id/custom_fields'
  },
  patchStudentCustomFields: {
    method: patch,
    path: '/students/:student_id/custom_fields/:id'
  },
  destroyStudentCustomFields: {
    method: destroy,
    path: '/students/:student_id/custom_fields/:id'
  },
  getApplicationCustomFields: {
    method: get,
    path: '/applications/:id/custom_fields'
  },
  postApplicationCustomFields: {
    method: post,
    path: '/applications/:id/custom_fields'
  },
  patchApplicationCustomFields: {
    method: patch,
    path: '/applications/:application_id/custom_fields/:id'
  },
  destroyApplicationCustomFields: {
    method: destroy,
    path: '/applications/:application_id/custom_fields/:id'
  },
  patchApplicationUpdateRequirements: {
    method: patch,
    path: '/applications/:id/update_requirements'
  },
  getNoteTemplates: {
    method: get,
    path: '/note_templates/search'
  },
  getSingleNoteTemplates: {
    method: get,
    path: '/note_templates/:id'
  },
  getNoteTemplatesTagDefinitions: {
    method: get,
    path: '/note_templates/tag_definitions'
  },
  getNoteTemplatesPopulateApplication: {
    method: get,
    path: '/note_templates/:id/populate',
    required: ['application_id']
  },
  createBulkNotes: {
    method: post,
    path: '/v0.1/notes/bulk_create'
  },
  createNoteTemplate: {
    method: post,
    path: '/note_templates'
  },
  editNoteTemplate: {
    method: patch,
    path: '/note_templates/:id'
  },
  destroyNoteTemplate: {
    method: destroy,
    path: '/note_templates/:id'
  },
  // Roles & Permissions
  getRoles: {
    method: get,
    path: '/roles'
  },
  getRole: {
    method: get,
    path: '/roles/:id'
  },
  getResources: {
    method: get,
    path: '/resources'
  },
  getRolePermissions: {
    method: get,
    path: '/roles/:id/permissions'
  },
  postRole: {
    method: post,
    path: '/roles'
  },
  patchRole: {
    method: patch,
    path: '/roles/:id'
  },
  putRolePermissions: {
    method: put,
    path: '/roles/:id/permissions'
  },
  // Requirement templates
  deleteRequirementAttachment: {
    method: destroy,
    path: '/requirement_templates/:template_id/additional_attachments/:id'
  },
  deleteRequirementExternalLink: {
    method: destroy,
    path: '/requirement_templates/:template_id/external_links/:id'
  },
  deleteRequirementQuestion: {
    method: destroy,
    path: '/requirement_templates/:template_id/questions/:id'
  },
  getRequirementTemplate: {
    method: get,
    path: '/requirement_templates/:id'
  },
  patchRequirementTemplate: {
    method: patch,
    path: '/requirement_templates/:template_id'
  },
  patchRequirementTemplateProgram: {
    method: patch,
    path: '/requirement_templates/:template_id/programs'
  },
  patchQuestionRequirementQuestion: {
    method: patch,
    path: '/requirement_templates/:template_id/questions/:id'
  },
  postQuestionRequirementQuestions: {
    method: post,
    path: '/requirement_templates/:id/questions'
  },
  postRequirementExternalLinks: {
    method: post,
    path: '/requirement_templates/:id/external_links'
  },
  postRequirementTemplate: {
    method: post,
    path: '/requirement_templates'
  },
  putRequirementTemplate: {
    method: put,
    path: '/requirement_templates/:template_id'
  },
  // Application requirements
  postApplicationRequirementAdditionalAttachment: {
    method: post,
    path: '/application_requirements/:application_requirement_id/application_additional_attachments'
  },
  deleteApplicationRequirementExternalLink: {
    method: destroy,
    path: '/application_requirements/:application_requirement_id/application_external_links/:id'
  },
  deleteApplicationRequirementAdditionalAttachment: {
    method: destroy,
    path: '/application_requirements/:application_requirement_id/application_additional_attachments/:id'
  },
  postApplicationRequirementFromTemplate: {
    method: post,
    path: '/applications/:application_id/application_requirements'
  },
  patchApplicationRequirement: {
    method: patch,
    path: '/application_requirements/:application_requirement_id'
  },
  patchApplicationRequirementReviewStatus: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/review'
  },
  patchApplicationRequirementApproveStatus: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/approve'
  },
  patchApplicationRequirementDisapproveStatus: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/disapprove'
  },
  patchApplicationRequirementOptional: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/optional'
  },
  patchApplicationRequirementRequired: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/required'
  },
  patchApplicationRequirementInactive: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/inactive'
  },
  // Questions types only
  postApplicationRequirementQuestion: {
    method: post,
    path: '/application_requirements/:application_requirement_id/application_questions'
  },
  patchApplicationRequirementQuestion: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id'
  },
  deleteApplicationRequirementQuestion: {
    method: destroy,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id'
  },
  postApplicationRequirementAnswer: {
    method: post,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id/answer'
  },
  patchApplicationRequirementApproveAnswer: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/approve'
  },
  patchApplicationRequirementDisapproveAnswer: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/disapprove'
  },
  patchApplicationRequirementAnswerStatusNote: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/update_note'
  },
  patchApplicationRequirementAnswer: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/application_questions/:question_id/application_question_answers/:id/update_answer'
  },
  // Document and Payment types only
  postApplicationRequirementAttachment: {
    method: post,
    path: '/application_requirements/:application_requirement_id/requirement_attachments'
  },
  patchApplicationRequirementApproveAttachment: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/requirement_attachments/:id/approve'
  },
  patchApplicationRequirementDisapproveAttachment: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/requirement_attachments/:id/disapprove'
  },
  patchApplicationRequirementAttachmentStatusNote: {
    method: patch,
    path: '/application_requirements/:application_requirement_id/requirement_attachments/:id/update_note'
  },
  // Conditions
  getConditionTemplates: {
    method: get,
    path: '/conditions'
  },
  getConditionTemplate: {
    method: get,
    path: '/conditions/:id'
  },
  getConditionTypes: {
    method: get,
    path: '/conditions/types'
  },
  getConditionResourcesAttributes: {
    method: get,
    path: '/condition_resources/'
  },
  getConditionOperations: {
    method: get,
    path: '/condition_resources/operations'
  },
  postConditionTemplate: {
    method: post,
    path: '/conditions'
  },
  patchConditionTemplate: {
    method: patch,
    path: '/conditions/:id'
  },
  deleteConditionTemplate: {
    method: destroy,
    path: '/conditions/:id'
  },
  getAccessScopes: {
    method: get,
    path: '/conditions/access_scopes'
  },
  // Important Updates
  getImportantUpdatesRequirements: {
    method: get,
    path: '/important_updates/requirements'
  },
  getImportantUpdatesMissingRequirements: {
    method: get,
    path: '/important_updates/missing_requirements'
  },
  getImportantUpdatesNotes: {
    method: get,
    path: '/important_updates/notes'
  },
  getImportantUpdatesCounts: {
    method: get,
    path: '/v2/important_updates/counts'
  },
  // Agent Dashboard
  getAgencyApplicationsStats: {
    method: get,
    path: '/agencies/:id/agency_stats/applications_stats'
  },
  getAgencyAccountBalance: {
    method: get,
    path: '/agencies/:id/agency_stats/balance'
  },
  getAgencyPotentialRevenue: {
    method: get,
    path: '/agencies/:id/agency_stats/potential_revenue'
  },
  getAgencyTopSchools: {
    method: get,
    path: '/agencies/:id/agency_stats/top_schools'
  },
  getAgencyRecentPrograms: {
    method: get,
    path: '/agencies/:id/agency_stats/recent_programs'
  },
  getAgencyCommissionHistory: {
    method: get,
    path: '/agencies/:id/agency_stats/commission_history'
  },
  getAgencyConversionStats: {
    method: get,
    path: '/agencies/:id/agency_stats/conversion_stats'
  },
  postAgencAddStudent: {
    method: post,
    path: '/agencies/:agency_id/students'
  },
  // Agent Regional Managers
  getAgentRegionalManager: {
    method: get,
    path: '/agent_regional_managers'
  },
  postAgentRegionalManager: {
    method: post,
    path: '/agent_regional_managers'
  },
  patchAssignAgentRegionalManager: {
    method: patch,
    path: '/assign_agent_regional_manager'
  },
  // Refunds
  getRefundableAmount: {
    method: get,
    path: '/applications/:id/refundable_amount'
  },
  postApplicationRefund: {
    method: post,
    path: '/applications/:id/refund'
  },
  // Credits
  getCreditableAmount: {
    method: get,
    path: '/applications/:id/creditable_amount'
  },
  postApplicationCredit: {
    method: post,
    path: '/applications/:id/credit'
  }
};
var config = {
  baseUrl: "".concat(API_ROOT, "/api"),
  configureHeaders: function configureHeaders(headers) {
    return _objectSpread(_objectSpread({}, headers), {}, {
      'x-csrf-token': getCsrf(),
      'X-Requested-With': 'XMLHttpRequest'
    });
  },
  configureOptions: function configureOptions(options) {
    return _objectSpread(_objectSpread({}, options), {}, {
      credentials: 'include'
    });
  }
};
var jsonApi = buildApi(apiEndpoints, config);
export var getUserAction = jsonApi.getUser;
export var getCurrentUserAction = jsonApi.getCurrentUser;
export var getMenuItemsAction = jsonApi.getMenuItems;
export var getUsersLegacyRolesAction = jsonApi.getUsersLegacyRoles;
export var getAccessScopesAction = jsonApi.getAccessScopes;
export var deleteUserProfilePictureAction = jsonApi.deleteUserProfilePicture;
export var patchUserPasswordAction = jsonApi.patchUserPassword;
export var patchUserUsernameAction = jsonApi.patchUserUsername;
export var patchUserEmailAction = jsonApi.patchUserEmail;
export var patchUserBlockAction = jsonApi.patchUserBlock;
export var patchUserUnblockAction = jsonApi.patchUserUnblock;
export var patchUserAssignRolesAction = jsonApi.patchUserAssignRoles;
export var patchUserLegacyRoleAction = jsonApi.patchUserLegacyRole;
export var putUserAccessScopesAction = jsonApi.putUserAccessScopes;
export var getUserProfileAction = jsonApi.getUserProfile;
export var patchUserProfileAction = jsonApi.patchUserProfile;
export var getCountriesAction = jsonApi.getCountries;
export var getSchoolAction = jsonApi.getSchool;
export var getSchoolsAction = jsonApi.getSchools;
export var getSchoolsSearchAction = jsonApi.getSchoolsSearch;
export var getProgramLevelsAction = jsonApi.getProgramLevels;
export var getSchoolProgramsAction = jsonApi.getSchoolPrograms;
export var getSchoolProgramAction = jsonApi.getSchoolProgram;
export var postAnonymousSchoolEligibilityCheckAction = jsonApi.postAnonymousSchoolEligibilityCheck;
export var postAnonymousProgramEligibilityCheckAction = jsonApi.postAnonymousProgramEligibilityCheck;
export var getStudentProgramEligibilityCheckAction = jsonApi.getStudentProgramEligibilityCheck;
export var getProgramDisclaimerRequirementsAction = jsonApi.getProgramDisclaimerRequirements;
export var getSchoolsListAction = jsonApi.getSchoolsList;
export var getSchoolAddressAction = jsonApi.getSchoolAddress;
export var getEducationHistoriesAction = jsonApi.getEducationHistories;
export var postEducationHistoriesAction = jsonApi.postEducationHistories;
export var putEducationHistoriesAction = jsonApi.putEducationHistories;
export var deleteEducationHistoriesAction = jsonApi.deleteEducationHistories;
export var deleteStudentsChargeAction = jsonApi.deleteStudentsCharge;
export var getStudentAction = jsonApi.getStudent;
export var getStudentsSearchAction = jsonApi.getStudentsSearch;
export var getStudentsOrdersAction = jsonApi.getStudentsOrders;
export var getStudentTestScoresAction = jsonApi.getStudentTestScores;
export var postStudentsChargeAction = jsonApi.postStudentsCharge;
export var patchStudentPremiumStatusAction = jsonApi.patchStudentPremiumStatus;
export var getStudentProfileDocumentsAction = jsonApi.getStudentProfileDocuments;
export var deleteStudentProfileDocumentsAttachmentAction = jsonApi.deleteStudentProfileDocumentsAttachment;
export var putStudentsAgencyAction = jsonApi.putStudentsAgency;
export var destroyStudentsAgencyAction = jsonApi.destroyStudentsAgency;
export var putStudentsSalesRepAction = jsonApi.putStudentsSalesRep;
export var destroyStudentsSalesRepAction = jsonApi.destroyStudentsSalesRep;
var patchAgentAgreement = jsonApi.patchAgentAgreement;
export { patchAgentAgreement };
export var deleteAgentsChargeAction = jsonApi.deleteAgentsCharge;
export var getAgentsOrdersAction = jsonApi.getAgentsOrders;
export var postAgentsChargeAction = jsonApi.postAgentsCharge;
export var getApplicationsSearchAction = jsonApi.getApplicationsSearch;
export var postServiceFeeWaiversAction = jsonApi.postServiceFeeWaivers;
export var destroyServiceFeeWaiversAction = jsonApi.destroyServiceFeeWaivers;
export var patchPaymentsAction = jsonApi.patchPayments;
export var patchPaymentsVerifyManualPaymentReceiptAction = jsonApi.patchPaymentsVerifyManualPaymentReceipt;
export var patchPaymentsDeleteManualPaymentReceiptAction = jsonApi.patchPaymentsDeleteManualPaymentReceipt;
export var getPromotionsAction = jsonApi.getPromotions;
export var postPromotionsAction = jsonApi.postPromotions;
export var patchPromotionsAction = jsonApi.patchPromotions;
export var destroyPromotionsAction = jsonApi.destroyPromotions;
export var getOrdersAction = jsonApi.getOrders;
export var patchOrdersAction = jsonApi.patchOrders;
export var getBillingAccountsAction = jsonApi.getBillingAccounts;
export var payOrderAction = jsonApi.payOrder;
export var createPaymentAction = jsonApi.createPayment;
export var postTransactionsAction = jsonApi.postTransaction;
export var getAgencyRegistrationRequestsAction = jsonApi.getAgencyRegistrationRequests;
export var getAgencyRegistrationAction = jsonApi.getAgencyRegistration;
export var postAgencyRegistrationAction = jsonApi.postAgencyRegistration;
export var patchAgencyRegistrationRequestsAction = jsonApi.patchAgencyRegistration;
export var deleteAgencyManagerAction = jsonApi.deleteAgencyManager;
export var getAgenciesAction = jsonApi.getAgencies;
export var getAgencyAction = jsonApi.getAgency;
export var getRpSearchAction = jsonApi.getRpSearch;
export var getAgencyAgentManagerAction = jsonApi.getAgencyAgentManager;
export var getAgencyApplicationStatsAction = jsonApi.getAgencyApplicationStats;
export var getAgencyBankingInformationAction = jsonApi.getAgencyBankingInformation;
export var getAgencyBillingAccountAction = jsonApi.getAgencyBillingAccount;
export var getAgencyCommissionPolicyAction = jsonApi.getAgencyCommissionPolicy;
export var getAgencySalesRepresentativeAction = jsonApi.getAgencySalesRepresentative;
export var patchAgencyAction = jsonApi.patchAgency;
export var patchAgencyBankingInformationAction = jsonApi.patchAgencyBankingInformation;
export var patchAgencyCommissionPolicyAction = jsonApi.patchAgencyCommissionPolicy;
export var patchAgencySendActivationEmailAction = jsonApi.patchAgencySendActivationEmail;
export var postAgencyReferralCodeAction = jsonApi.postAgencyReferralCode;
export var putAgencyManagerAction = jsonApi.putAgencyManager;
export var getAgencySchoolCommissionsAction = jsonApi.getAgencySchoolCommissions;
export var patchAgencyActivationAction = jsonApi.patchAgencyActivation;
export var patchAgencyDeactivationAction = jsonApi.patchAgencyDeactivation;
export var patchAgencySuspensionAction = jsonApi.patchAgencySuspension;
export var postAgencyStaffInvitationAction = jsonApi.postAgencyStaffInvitation;
export var getAgencyStaffInvitationsAction = jsonApi.getAgencyStaffInvitations;
export var postAgencySendStaffInvitationAction = jsonApi.postAgencySendStaffInvitation;
export var patchAgencyStaffLimitAction = jsonApi.patchAgencyStaffLimit;
export var patchAgencyAutoAddSchoolsAction = jsonApi.patchAgencyAutoAddSchools;
export var patchAgencyReassignStudentsAction = jsonApi.patchAgencyReassignStudents;
export var getPaidApplicationsCountForAgentAction = jsonApi.getPaidApplicationsCountForAgent;
export var getPaidStudentsCountForAgentAction = jsonApi.getPaidStudentsCountForAgent;
export var getEarliestPaidStudentDateForAgentAction = jsonApi.getEarliestPaidStudentDateForAgent;
export var getAgentManagersAction = jsonApi.getAgentManagers;
export var getAgentManagerAction = jsonApi.getAgentManager;
export var getSalesRepresentativesAction = jsonApi.getSalesRepresentatives;
export var getStudentSalesRepresentativesAction = jsonApi.getStudentSalesRepresentatives;
export var getSalesRepresentativeAction = jsonApi.getSalesRepresentative;
export var getImmigrationConsultantAction = jsonApi.getImmigrationConsultant;
export var getStudentImmigrationConsultantsAction = jsonApi.getStudentImmigrationConsultants;
export var putStudentImmigrationConsultantAction = jsonApi.putStudentImmigrationConsultant;
export var destroyStudentImmigrationConsultantAction = jsonApi.destroyStudentImmigrationConsultant;
export var putAgencyEmployeeAction = jsonApi.putAgencyEmployee;
export var getAgencyEmployeeAction = jsonApi.getAgencyEmployee;
export var getIeltsResultsAction = jsonApi.getIeltsResults;
export var createApplyStuEmailAction = jsonApi.createApplyStuEmail;
export var patchAgencyRegistrationAction = jsonApi.patchAgencyRegistration;
export var getSingleAgencyRegistrationRequestAction = jsonApi.getSingleAgencyRegistrationRequest;
export var patchAgencyRegistrationApproveAction = jsonApi.patchAgencyRegistrationApprove;
export var patchAgencyRegistrationRejectAction = jsonApi.patchAgencyRegistrationReject;
export var patchAgencyRegistrationSetUnderReviewAction = jsonApi.patchAgencyRegistrationSetUnderReview;
export var patchAgencyRegistrationUnsetUnderReviewAction = jsonApi.patchAgencyRegistrationUnsetUnderReview;
export var getAgencyAdminCommentsAction = jsonApi.getAgencyAdminComments;
export var postAgencyAdminCommentAction = jsonApi.postAgencyAdminComment;
export var destroyAgencyAdminCommentAction = jsonApi.destroyAgencyAdminComment;
export var getCustomFieldsAction = jsonApi.getCustomFields;
export var getCustomFieldDefinitionsAction = jsonApi.getCustomFieldDefinitions;
export var getStudentCustomFieldsAction = jsonApi.getStudentCustomFields;
export var postStudentCustomFieldsAction = jsonApi.postStudentCustomFields;
export var patchStudentCustomFieldsAction = jsonApi.patchStudentCustomFields;
export var destroyStudentCustomFieldsAction = jsonApi.destroyStudentCustomFields;
export var getApplicationCustomFieldsAction = jsonApi.getApplicationCustomFields;
export var postApplicationCustomFieldsAction = jsonApi.postApplicationCustomFields;
export var patchApplicationCustomFieldsAction = jsonApi.patchApplicationCustomFields;
export var destroyApplicationCustomFieldsAction = jsonApi.destroyApplicationCustomFields;
export var patchApplicationUpdateRequirementAction = jsonApi.patchApplicationUpdateRequirements;
export var getStudentApplicationsAction = jsonApi.getStudentApplications;
export var getNoteTemplatesAction = jsonApi.getNoteTemplates;
export var getSingleNoteTemplatesAction = jsonApi.getSingleNoteTemplates;
export var getNoteTemplatesTagDefinitionsAction = jsonApi.getNoteTemplatesTagDefinitions;
export var getNoteTemplatesPopulateApplicationAction = jsonApi.getNoteTemplatesPopulateApplication;
export var createNoteTemplateAction = jsonApi.createNoteTemplate;
export var editNoteTemplateAction = jsonApi.editNoteTemplate;
export var destroyNoteTemplateAction = jsonApi.destroyNoteTemplate;

// Roles
export var getRolesAction = jsonApi.getRoles;
export var getRoleAction = jsonApi.getRole;
export var getResourcesAction = jsonApi.getResources;
export var getRolePermissionsAction = jsonApi.getRolePermissions;
export var postRoleAction = jsonApi.postRole;
export var patchRoleAction = jsonApi.patchRole;
export var putRolePermissionsAction = jsonApi.putRolePermissions;

// Requirement templates
export var deleteRequirementAttachmentAction = jsonApi.deleteRequirementAttachment;
export var deleteRequirementExternalLinkAction = jsonApi.deleteRequirementExternalLink;
export var deleteRequirementQuestionAction = jsonApi.deleteRequirementQuestion;
export var getRequirementTemplateAction = jsonApi.getRequirementTemplate;
export var patchRequirementTemplateAction = jsonApi.patchRequirementTemplate;
export var patchRequirementTemplateProgramAction = jsonApi.patchRequirementTemplateProgram;
export var patchQuestionRequirementQuestionAction = jsonApi.patchQuestionRequirementQuestion;
export var postQuestionRequirementQuestionsAction = jsonApi.postQuestionRequirementQuestions;
export var postRequirementExternalLinksAction = jsonApi.postRequirementExternalLinks;
export var postRequirementTemplateAction = jsonApi.postRequirementTemplate;
export var putRequirementTemplateAction = jsonApi.putRequirementTemplate;
export var getConditionTemplatesAction = jsonApi.getConditionTemplates;
export var getConditionTemplateAction = jsonApi.getConditionTemplate;
export var getConditionResourcesAttributesAction = jsonApi.getConditionResourcesAttributes;
var getConditionTypes = jsonApi.getConditionTypes;
export { getConditionTypes };
export var getConditionOperationsAction = jsonApi.getConditionOperations;
export var postConditionTemplateAction = jsonApi.postConditionTemplate;
export var patchConditionTemplateAction = jsonApi.patchConditionTemplate;
export var deleteConditionTemplateAction = jsonApi.deleteConditionTemplate;

// Important Updates
export var getImportantUpdatesMissingRequirementsAction = jsonApi.getImportantUpdatesMissingRequirements;
export var getImportantUpdatesRequirementsAction = jsonApi.getImportantUpdatesRequirements;
export var getImportantUpdatesNotesAction = jsonApi.getImportantUpdatesNotes;
export var getImportantUpdatesCountsAction = jsonApi.getImportantUpdatesCounts;

// Agent Dashboard
export var getAgencyApplicationsStatsAction = jsonApi.getAgencyApplicationsStats;
export var getAgencyAccountBalanceAction = jsonApi.getAgencyAccountBalance;
export var getAgencyPotentialRevenueAction = jsonApi.getAgencyPotentialRevenue;
export var getAgencyTopSchoolsAction = jsonApi.getAgencyTopSchools;
export var getAgencyRecentProgramsAction = jsonApi.getAgencyRecentPrograms;
export var getAgencyCommissionHistoryAction = jsonApi.getAgencyCommissionHistory;
export var getAgencyConversionStatsAction = jsonApi.getAgencyConversionStats;
export var postAgencAddStudentAction = jsonApi.postAgencAddStudent;

// Agent Regional Managers
export var postAgentRegionalManagerAction = jsonApi.postAgentRegionalManager;
export var getAgentRegionalManagerAction = jsonApi.getAgentRegionalManager;
export var patchAssignAgentRegionalManagerAction = jsonApi.patchAssignAgentRegionalManager;

// Payments

// Refunds
export var getRefundableAmountAction = jsonApi.getRefundableAmount;
export var postApplicationRefundAction = jsonApi.postApplicationRefund;

// Credits
export var getCreditableAmountAction = jsonApi.getCreditableAmount;
export var postApplicationCreditAction = jsonApi.postApplicationCredit;
export default jsonApi;